<template>
  <div class="">
    <div class="row" style="margin-left:0px;margin-right:2px;">
      <div class="col-lg-5 mt-5 m-left">
        <div class="title model-info">
          {{ name }}
        </div>
        <h3 class="description mt-3 mb-4 model-info">
          {{ description }}
        </h3>
        <div
          v-for="(credit, i) in credits"
          :key="i"
          class="row mt-1 align-items-center justify-content-start model-info"
        >
          <div class="col-10 mx-2 label-function">
            <strong>{{ credit.functions }}</strong> : {{ credit.persons }}
          </div>
        </div>
      </div>
      <div class="col-lg-7 img-credits">
        <!-- tamanho das capas (1100×838): a caixa fica reservada até a imagem
             chegar, sem empurrar o banner de baixo -->
        <img
          class="img-perfil-model"
          :src="imgPerfil"
          :alt="imageAltText"
          width="1100"
          height="838"
          srcset=""
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  credits: {
    type: Object,
    required: true,
  },
});

const name = computed(() => props.model.nameModel);
const imageAltText = computed(() => props.model.imageAltText ?? props.model.nameModel);
const description = computed(() => props.model.descriptionModel);
const imgPerfil = computed(() => props.model.imgPerfil);
const credits = computed(() => props.credits.credits);
</script>
<style scoped lang="css">
h3 h1 p {
  font-family: "Exo-2";
}

h3 {
  font-weight: 600;
}
.label-function {
  color: #444444;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 32px;
}

.model-info {
  padding-left: 108px;
}

.title {
  color: #000000;
  font-family: "Bebas-Neue";
  font-size: 72px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 72px;
}

.description {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}
.row .buttons-video > .col,
.row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.img-perfil-model {
  width: 100%;
  height: auto;
  right: -5px;
}

.img-credits {
  padding-right: 17px !important;
}

@media screen and (max-width: 992px) {
  .img-credits {
    display: none;
  }
  .block {
    padding: 0px;
    margin-top: 0px;
  }

  .model-info {
    padding-left: 0px;
  }

  .title {
    font-size: 40px;
    line-height: 56px;
  }

  .m-left {
    padding-left: 50px !important;
  }
}
</style>
